// extracted by mini-css-extract-plugin
module.exports = {"title":"detail_title__-RL9r"};